import locale9ec66352 from '../../../../lang/json/en.json'

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
  REDIRECT_ON_OPTIONS: {"ALL":"all","ROOT":"root","NO_PREFIX":"no prefix"},
}
export const nuxtOptions = {
  isUniversalMode: false,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {"fallbackLocale":"en","numberFormats":{"en":{"currency":{"style":"currency","currency":"EUR","currencyDisplay":"narrowSymbol"},"currency-no-decimal":{"style":"currency","currency":"EUR","currencyDisplay":"narrowSymbol","maximumFractionDigits":0,"minimumFractionDigits":0},"percent":{"style":"percent","useGrouping":false},"liter":{"style":"unit","unit":"liter","unitDisplay":"narrow"},"weight":{"style":"unit","unit":"gram","unitDisplay":"narrow"},"length":{"style":"unit","unit":"centimeter","unitDisplay":"narrow"},"numberAbbreviation":{"style":"decimal","notation":"compact","maximumFractionDigits":1}},"nl":{"currency":{"style":"currency","currency":"EUR","currencyDisplay":"narrowSymbol"},"currency-no-decimal":{"style":"currency","currency":"EUR","currencyDisplay":"narrowSymbol","maximumFractionDigits":0,"minimumFractionDigits":0},"percent":{"style":"percent","useGrouping":false},"liter":{"style":"unit","unit":"liter","unitDisplay":"narrow"},"weight":{"style":"unit","unit":"gram","unitDisplay":"narrow"},"length":{"style":"unit","unit":"centimeter","unitDisplay":"narrow"},"numberAbbreviation":{"style":"decimal","notation":"compact","maximumFractionDigits":1}},"de":{"currency":{"style":"currency","currency":"EUR","currencyDisplay":"narrowSymbol"},"currency-no-decimal":{"style":"currency","currency":"EUR","currencyDisplay":"narrowSymbol","maximumFractionDigits":0,"minimumFractionDigits":0},"percent":{"style":"percent","useGrouping":false},"liter":{"style":"unit","unit":"liter","unitDisplay":"narrow"},"weight":{"style":"unit","unit":"gram","unitDisplay":"narrow"},"length":{"style":"unit","unit":"centimeter","unitDisplay":"narrow"},"numberAbbreviation":{"style":"decimal","notation":"compact","maximumFractionDigits":1}},"fr":{"currency":{"style":"currency","currency":"EUR","currencyDisplay":"narrowSymbol"},"currency-no-decimal":{"style":"currency","currency":"EUR","currencyDisplay":"narrowSymbol","maximumFractionDigits":0,"minimumFractionDigits":0},"percent":{"style":"percent","useGrouping":false},"liter":{"style":"unit","unit":"liter","unitDisplay":"narrow"},"weight":{"style":"unit","unit":"gram","unitDisplay":"narrow"},"length":{"style":"unit","unit":"centimeter","unitDisplay":"narrow"},"numberAbbreviation":{"style":"decimal","notation":"compact","maximumFractionDigits":1}},"it":{"currency":{"style":"currency","currency":"EUR","currencyDisplay":"narrowSymbol"},"currency-no-decimal":{"style":"currency","currency":"EUR","currencyDisplay":"narrowSymbol","maximumFractionDigits":0,"minimumFractionDigits":0},"percent":{"style":"percent","useGrouping":false},"liter":{"style":"unit","unit":"liter","unitDisplay":"narrow"},"weight":{"style":"unit","unit":"gram","unitDisplay":"narrow"},"length":{"style":"unit","unit":"centimeter","unitDisplay":"narrow"},"numberAbbreviation":{"style":"decimal","notation":"compact","maximumFractionDigits":1}},"es":{"currency":{"style":"currency","currency":"EUR","currencyDisplay":"narrowSymbol"},"currency-no-decimal":{"style":"currency","currency":"EUR","currencyDisplay":"narrowSymbol","maximumFractionDigits":0,"minimumFractionDigits":0},"percent":{"style":"percent","useGrouping":false},"liter":{"style":"unit","unit":"liter","unitDisplay":"narrow"},"weight":{"style":"unit","unit":"gram","unitDisplay":"narrow"},"length":{"style":"unit","unit":"centimeter","unitDisplay":"narrow"},"numberAbbreviation":{"style":"decimal","notation":"compact","maximumFractionDigits":1}},"da":{"currency":{"style":"currency","currency":"EUR","currencyDisplay":"narrowSymbol"},"currency-no-decimal":{"style":"currency","currency":"EUR","currencyDisplay":"narrowSymbol","maximumFractionDigits":0,"minimumFractionDigits":0},"percent":{"style":"percent","useGrouping":false},"liter":{"style":"unit","unit":"liter","unitDisplay":"narrow"},"weight":{"style":"unit","unit":"gram","unitDisplay":"narrow"},"length":{"style":"unit","unit":"centimeter","unitDisplay":"narrow"},"numberAbbreviation":{"style":"decimal","notation":"compact","maximumFractionDigits":1}},"pl":{"currency":{"style":"currency","currency":"EUR","currencyDisplay":"narrowSymbol"},"currency-no-decimal":{"style":"currency","currency":"EUR","currencyDisplay":"narrowSymbol","maximumFractionDigits":0,"minimumFractionDigits":0},"percent":{"style":"percent","useGrouping":false},"liter":{"style":"unit","unit":"liter","unitDisplay":"narrow"},"weight":{"style":"unit","unit":"gram","unitDisplay":"narrow"},"length":{"style":"unit","unit":"centimeter","unitDisplay":"narrow"},"numberAbbreviation":{"style":"decimal","notation":"compact","maximumFractionDigits":1}}},"pluralizationRules":{}},
  vueI18nLoader: false,
  locales: [{"code":"en","name":"English","iso":"en-GB","file":"en.json"},{"code":"nl","name":"Nederlands","iso":"nl-NL","file":"nl.json"},{"code":"de","name":"Deutsch","iso":"de-DE","file":"de-DE.json"},{"code":"fr","name":"Français","iso":"fr-FR","file":"fr-FR.json"},{"code":"pl","name":"Polski","iso":"pl-PL","file":"pl-PL.json"},{"code":"da","name":"Dansk","iso":"da-DK","file":"da-DK.json"},{"code":"it","name":"Italiano","iso":"it-IT","file":"it-IT.json"},{"code":"es","name":"Español","iso":"es-ES","file":"es-ES.json"}],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "../../lang/json/",
  rootRedirect: null,
  detectBrowserLanguage: {"alwaysRedirect":false,"cookieAge":365,"cookieCrossOrigin":false,"cookieDomain":null,"cookieKey":"i18n_redirected","cookieSecure":false,"fallbackLocale":"","redirectOn":"root","useCookie":true},
  differentDomains: false,
  baseUrl: function (nuxtContext) {
      return nuxtContext.$config.appUrl;
    },
  vuex: {"moduleName":"i18n","syncRouteParams":true},
  parsePages: true,
  pages: {},
  skipSettingLocaleOnNavigate: false,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  normalizedLocales: [{"code":"en","name":"English","iso":"en-GB","file":"en.json"},{"code":"nl","name":"Nederlands","iso":"nl-NL","file":"nl.json"},{"code":"de","name":"Deutsch","iso":"de-DE","file":"de-DE.json"},{"code":"fr","name":"Français","iso":"fr-FR","file":"fr-FR.json"},{"code":"pl","name":"Polski","iso":"pl-PL","file":"pl-PL.json"},{"code":"da","name":"Dansk","iso":"da-DK","file":"da-DK.json"},{"code":"it","name":"Italiano","iso":"it-IT","file":"it-IT.json"},{"code":"es","name":"Español","iso":"es-ES","file":"es-ES.json"}],
  localeCodes: ["en","nl","de","fr","pl","da","it","es"],
  additionalMessages: [],
}
export const localeFiles = {
  0: "{",
  1: "\"",
  2: "e",
  3: "n",
  4: ".",
  5: "j",
  6: "s",
  7: "o",
  8: "n",
  9: "\"",
  10: ":",
  11: "\"",
  12: ".",
  13: ".",
  14: "/",
  15: ".",
  16: ".",
  17: "/",
  18: ".",
  19: ".",
  20: "/",
  21: "l",
  22: "a",
  23: "n",
  24: "g",
  25: "/",
  26: "j",
  27: "s",
  28: "o",
  29: "n",
  30: "/",
  31: "e",
  32: "n",
  33: ".",
  34: "j",
  35: "s",
  36: "o",
  37: "n",
  38: "\"",
  39: ",",
  40: "\"",
  41: "n",
  42: "l",
  43: ".",
  44: "j",
  45: "s",
  46: "o",
  47: "n",
  48: "\"",
  49: ":",
  50: "\"",
  51: ".",
  52: ".",
  53: "/",
  54: ".",
  55: ".",
  56: "/",
  57: ".",
  58: ".",
  59: "/",
  60: "l",
  61: "a",
  62: "n",
  63: "g",
  64: "/",
  65: "j",
  66: "s",
  67: "o",
  68: "n",
  69: "/",
  70: "n",
  71: "l",
  72: ".",
  73: "j",
  74: "s",
  75: "o",
  76: "n",
  77: "\"",
  78: ",",
  79: "\"",
  80: "d",
  81: "e",
  82: "-",
  83: "D",
  84: "E",
  85: ".",
  86: "j",
  87: "s",
  88: "o",
  89: "n",
  90: "\"",
  91: ":",
  92: "\"",
  93: ".",
  94: ".",
  95: "/",
  96: ".",
  97: ".",
  98: "/",
  99: ".",
  100: ".",
  101: "/",
  102: "l",
  103: "a",
  104: "n",
  105: "g",
  106: "/",
  107: "j",
  108: "s",
  109: "o",
  110: "n",
  111: "/",
  112: "d",
  113: "e",
  114: "-",
  115: "D",
  116: "E",
  117: ".",
  118: "j",
  119: "s",
  120: "o",
  121: "n",
  122: "\"",
  123: ",",
  124: "\"",
  125: "f",
  126: "r",
  127: "-",
  128: "F",
  129: "R",
  130: ".",
  131: "j",
  132: "s",
  133: "o",
  134: "n",
  135: "\"",
  136: ":",
  137: "\"",
  138: ".",
  139: ".",
  140: "/",
  141: ".",
  142: ".",
  143: "/",
  144: ".",
  145: ".",
  146: "/",
  147: "l",
  148: "a",
  149: "n",
  150: "g",
  151: "/",
  152: "j",
  153: "s",
  154: "o",
  155: "n",
  156: "/",
  157: "f",
  158: "r",
  159: "-",
  160: "F",
  161: "R",
  162: ".",
  163: "j",
  164: "s",
  165: "o",
  166: "n",
  167: "\"",
  168: ",",
  169: "\"",
  170: "p",
  171: "l",
  172: "-",
  173: "P",
  174: "L",
  175: ".",
  176: "j",
  177: "s",
  178: "o",
  179: "n",
  180: "\"",
  181: ":",
  182: "\"",
  183: ".",
  184: ".",
  185: "/",
  186: ".",
  187: ".",
  188: "/",
  189: ".",
  190: ".",
  191: "/",
  192: "l",
  193: "a",
  194: "n",
  195: "g",
  196: "/",
  197: "j",
  198: "s",
  199: "o",
  200: "n",
  201: "/",
  202: "p",
  203: "l",
  204: "-",
  205: "P",
  206: "L",
  207: ".",
  208: "j",
  209: "s",
  210: "o",
  211: "n",
  212: "\"",
  213: ",",
  214: "\"",
  215: "d",
  216: "a",
  217: "-",
  218: "D",
  219: "K",
  220: ".",
  221: "j",
  222: "s",
  223: "o",
  224: "n",
  225: "\"",
  226: ":",
  227: "\"",
  228: ".",
  229: ".",
  230: "/",
  231: ".",
  232: ".",
  233: "/",
  234: ".",
  235: ".",
  236: "/",
  237: "l",
  238: "a",
  239: "n",
  240: "g",
  241: "/",
  242: "j",
  243: "s",
  244: "o",
  245: "n",
  246: "/",
  247: "d",
  248: "a",
  249: "-",
  250: "D",
  251: "K",
  252: ".",
  253: "j",
  254: "s",
  255: "o",
  256: "n",
  257: "\"",
  258: ",",
  259: "\"",
  260: "i",
  261: "t",
  262: "-",
  263: "I",
  264: "T",
  265: ".",
  266: "j",
  267: "s",
  268: "o",
  269: "n",
  270: "\"",
  271: ":",
  272: "\"",
  273: ".",
  274: ".",
  275: "/",
  276: ".",
  277: ".",
  278: "/",
  279: ".",
  280: ".",
  281: "/",
  282: "l",
  283: "a",
  284: "n",
  285: "g",
  286: "/",
  287: "j",
  288: "s",
  289: "o",
  290: "n",
  291: "/",
  292: "i",
  293: "t",
  294: "-",
  295: "I",
  296: "T",
  297: ".",
  298: "j",
  299: "s",
  300: "o",
  301: "n",
  302: "\"",
  303: ",",
  304: "\"",
  305: "e",
  306: "s",
  307: "-",
  308: "E",
  309: "S",
  310: ".",
  311: "j",
  312: "s",
  313: "o",
  314: "n",
  315: "\"",
  316: ":",
  317: "\"",
  318: ".",
  319: ".",
  320: "/",
  321: ".",
  322: ".",
  323: "/",
  324: ".",
  325: ".",
  326: "/",
  327: "l",
  328: "a",
  329: "n",
  330: "g",
  331: "/",
  332: "j",
  333: "s",
  334: "o",
  335: "n",
  336: "/",
  337: "e",
  338: "s",
  339: "-",
  340: "E",
  341: "S",
  342: ".",
  343: "j",
  344: "s",
  345: "o",
  346: "n",
  347: "\"",
  348: "}",
}

export const localeMessages = {
  'en.json': () => Promise.resolve(locale9ec66352),
  'nl.json': () => import('../../../../lang/json/nl.json' /* webpackChunkName: "lang-nl.json" */),
  'de-DE.json': () => import('../../../../lang/json/de-DE.json' /* webpackChunkName: "lang-de-DE.json" */),
  'fr-FR.json': () => import('../../../../lang/json/fr-FR.json' /* webpackChunkName: "lang-fr-FR.json" */),
  'pl-PL.json': () => import('../../../../lang/json/pl-PL.json' /* webpackChunkName: "lang-pl-PL.json" */),
  'da-DK.json': () => import('../../../../lang/json/da-DK.json' /* webpackChunkName: "lang-da-DK.json" */),
  'it-IT.json': () => import('../../../../lang/json/it-IT.json' /* webpackChunkName: "lang-it-IT.json" */),
  'es-ES.json': () => import('../../../../lang/json/es-ES.json' /* webpackChunkName: "lang-es-ES.json" */),
}
